<svelte:options customElement={{
  tag: 'news-stories',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' }
  }
}} />

<script>
  import { onMount, onDestroy } from 'svelte';
  /**
   * STORIES ニュースカード
   * 3カラム画像背景カード型。カテゴリ＋タイトルオーバーレイ
   * 1024px以下ではカルーセル表示
   * @prop {string} items - JSON配列 '[{"thumbnail":"...","category":"...","title":"...",
   * "icon":"...","href":"..."}]'
   */
  export let items = '[]';

  let parsedItems = [];
  let currentIndex = 0;
  let isMobile = false;
  const slidesPerView = 2;

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('NewsStories: Invalid items JSON', e);
      parsedItems = [];
    }
  }

  function checkMobile() {
    isMobile = window.innerWidth <= 1024;
  }

  function prev() {
    currentIndex = currentIndex > 0 ? currentIndex - 1 : Math.max(0, parsedItems.length - slidesPerView);
  }

  function next() {
    currentIndex = currentIndex < parsedItems.length - slidesPerView ? currentIndex + 1 : 0;
  }

  function goTo(index) {
    currentIndex = index;
  }

  onMount(() => {
    checkMobile();
    window.addEventListener('resize', checkMobile);
  });

  onDestroy(() => {
    window.removeEventListener('resize', checkMobile);
  });
</script>

{#if isMobile}
  <!-- カルーセルモード (1024px以下) -->
  <div class="top-stories-section__carousel rt_bn_news_stories">
    <div class="top-stories-section__carousel__track" style="transform: translateX(-{currentIndex * 50}%)">
      {#each parsedItems as item}
        <div class="top-stories-section__carousel__slide">
          <a href={item.href || '#'} class="top-stories-section__cards__card rt_bn_news_stories__card" target={item.blank ? '_blank' : null} rel={item.blank ? 'noopener noreferrer' : null}>
            <img src="{item.thumbnail}" alt="{item.alt}" loading="lazy" class="top-stories-section__cards__img rt_bn_news_stories__img">
            <div class="top-stories-section__cards__overlay rt_bn_news_stories__overlay">
                <p class="top-stories-section__cards__title rt_bn_news_stories__title">
                <span>{item.title && item.title.length > 19 ? item.title.substring(0, 19) + '...' : item.title || ''}</span>
                </p>
              <p class="top-stories-section__cards__more">
                <svg>
                  <use xlink:href='/common/svg/sprite.svg#arrow_right_circle' />
                </svg>
                <span>Read More</span>
              </p>
            </div>
          </a>
        </div>
      {/each}
    </div>

    {#if parsedItems.length > 1}
      {#if currentIndex > 0}
        <button type="button" class="top-stories-section__carousel__prev" on:click={prev} aria-label="前へ">
          <svg viewBox="0 0 24 24"><use xlink:href='/common/svg/sprite.svg#arrow_left' /></svg>
        </button>
      {/if}
      {#if currentIndex < parsedItems.length - slidesPerView}
        <button type="button" class="top-stories-section__carousel__next" on:click={next} aria-label="次へ">
          <svg viewBox="0 0 24 24"><use xlink:href='/common/svg/sprite.svg#arrow_right' /></svg>
        </button>
      {/if}
    {/if}
  </div>
{:else}
  <!-- グリッドモード (1025px以上) -->
  <div class="top-stories-section__cards rt_bn_news_stories">
    {#each parsedItems as item}
      <a href={item.href || '#'} class="top-stories-section__cards__card rt_bn_news_stories__card" target={item.blank ? '_blank' : null} rel={item.blank ? 'noopener noreferrer' : null}>
        <img src="{item.thumbnail}" alt="{item.alt}" loading="lazy" class="top-stories-section__cards__img rt_bn_news_stories__img">
        <div class="top-stories-section__cards__overlay rt_bn_news_stories__overlay">
          <!-- {#if item.category}
            <span class="top-stories-section__cards__card__category rt_bn_news_stories__category">{item.category}</span>
          {/if} -->
          <p class="top-stories-section__cards__title rt_bn_news_stories__title"><span>{item.title || ''}</span></p>
          <p class="top-stories-section__cards__more">
            <svg>
              <use xlink:href='/common/svg/sprite.svg#arrow_right_circle' />
            </svg>
            <span>Read More</span>
          </p>
        </div>
      </a>
    {/each}
  </div>
{/if}

<style>
  /* カルーセルラッパー */
  .top-stories-section__carousel {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  /* スライドトラック */
  .top-stories-section__carousel__track {
    display: flex;
    transition: transform 0.5s ease;
  }

  /* 各スライド（2枚同時表示） */
  .top-stories-section__carousel__slide {
    flex: 0 0 50%;
    min-width: 50%;
  }

  /* カード内のリンクをスライドに合わせて */
  .top-stories-section__carousel__slide .top-stories-section__cards__card {
    display: block;
    width: 100%;
  }

  /* 前へ / 次へ ボタン */
  .top-stories-section__carousel__prev,
  .top-stories-section__carousel__next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.65);
    backdrop-filter: blur(2.6315789222717285px);
    transition: background 0.3s;
    z-index: 1;
    padding: 0;
  }

  .top-stories-section__carousel__prev { left: 10px; }
  .top-stories-section__carousel__next { right: 10px; }

  .top-stories-section__carousel__prev svg,
  .top-stories-section__carousel__next svg {
    width: 16px;
    height: 16px;
    fill: #000;
  }

  /* ドットインジケーター */
  .top-stories-section__carousel__dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 12px;
  }

  .top-stories-section__carousel__dot {
    width: 10px;
    height: 10px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    transition: background 0.3s;
    padding: 0;
  }

  .top-stories-section__carousel__dot.is-active {
    background: rgba(0, 0, 0, 0.75);
  }
</style>